<template>
    <div>
        <h1 style="text-align: center;">Timeline Component Editor</h1>
        <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
        <div>
            <div ref="cntTitle">
                <h2>Title</h2>
                <div><input type="text" v-model="title" style="width: 100%"></div>
            </div>
            <div ref="cntThumb">
                <h2>Thumbnail</h2>
                <div><img :src="thumbnail.data" height="200px" width="100%" style="object-fit: contain;"></div>
                <div><input type="file" ref="thumbsel" v-on:change="changeImage(thumbnail, 'thumbsel')" accept="image/jpeg,image/png,image/tif" style="width: 100%; color: black;"></div>
            </div>
            <hr>
            <div class="x-cardbox">
                <div v-for="(slot, i) in data" :key="'cntCard-' + i" :ref="'cntCard-' + i" class="x-card">
                    <div :ref="'cntImg' + i">
                        <h2>Image #{{i+1}}</h2>
                        <div><img :src="slot.img.data" height="200px" width="100%" style="object-fit: contain;" :class="(slot.size == 2) ? 'size2' : ''"></div>
                        <div><input type="button" value="Browse File" @click="$refs['imgsel' + i][0].click()" style="width: 100%; background: black; color: white;"></div>
                        <div><input type="file" :ref="'imgsel' + i" v-on:change="changeImage(slot, 'imgsel' + i)" accept="image/jpeg,image/png,image/tif" style="display: none;"></div>
                    </div>
                    <div :ref="'cntDesc' + i">
                        <select v-model="slot.size" style="width: 100%; text-align: center;">
                            <option :value="1">Narrow</option>
                            <option :value="2">Wide</option>
                        </select>
                        <input type="text" v-model="slot.header" placeholder="Heading..." style="width: 100%; margin: 0.25em 0;">
                        <textarea v-model="slot.description" placeholder="Description">
                        </textarea>
                    </div>
                    <div>
                        <button @click="deleteImg(i)" style="width: 100%; font-size: 1.2em; background: maroon; color: white;">Remove Image</button>
                        <button @click="deleteSlot(i)" style="width: 100%; font-size: 1.2em; background: maroon; color: white;">Delete Slot</button>
                    </div>
                    <hr>
                </div>
            </div>
            <div>
                <button @click="addNew()" class="submit-btn">Add New Timeline Slot</button>
                <button @click="submitThis()" class="submit-btn">Submit</button>
                <hr>
            </div>
        </div>
    </div>
</template>

<script>
import {Functions} from './functions.js';
export default {
    name: "TimelineAddEditComponent",
    props: ["ID"],
    data: () => ({
        isLoading: true,
        title: "",
        id: undefined,
        data: [],
        thumbnail: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        functions: undefined,
        buffer: undefined
    }),
    mounted: function(){
        this.functions = new Functions();
        if(this.ID){
            console.log("EDITING");
            this.functions.getComponent(this.ID, (data) => {
                console.log(data);
                this.id = data.contentId;
                this.title = data.title;
                this.thumbnail.publicUrl = data.rdsDat[0].Thumbnail;
                this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg", "getObject", (thumbBuff) => {
                    this.thumbnail.data = (thumbBuff.signedUrl);
                    this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg", "putObject", (thumbBuff1) => {
                        this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
                        this.getImageSignedURL(0, data.data);
                    });
                });
            });
        }else{
            console.log("Create New");
            
            this.functions.getThumbURL((dat) => {
                this.thumbnail.publicUrl = dat.key;
                this.thumbnail.uploadUrl = dat.signedUrl;
                this.addNew();
            });
        }
    },
    methods: {
        getImageSignedURL(i, data){
            if(i >= data.entries.length){
                this.isLoading = false;
                return null;
            }
            console.log(data);
            this.data.push({
                img: {
                    file: undefined,
                    data: (data.entries[i].picture == null) ? '' : data.entries[i].picture,
                    publicUrl: (data.entries[i].picture == null) ? '' : data.entries[i].picture,
                    uploadUrl: undefined
                },
                header: data.entries[i].header,
                description: data.entries[i].description,
                ID: data.entries[i].ID,
                picture: data.entries[i].picture,
                size: data.entries[i].size,
                offset: data.entries[i].offset
            });
            if(data.entries[i].picture != null){
                this.functions.getSignedUrl("ttedu-public-uploads", data.entries[i].picture.replace("https://ttedu-public-uploads.s3.amazonaws.com/", ""), "image/jpeg", "putObject", (dat) => {
                    this.data[i].img.uploadUrl = dat.signedUrl;
                    this.getImageSignedURL(i+1, data);
                });
            }else{
                this.functions.getImageURL((dat) => {
                    this.data[i].img.publicUrl = dat.key;
                    this.data[i].img.uploadUrl = dat.signedUrl;
                    this.getImageSignedURL(i+1, data);
                });
            }
        },
        addNew: function(){
            this.isLoading = true;
            this.functions.getImageURL((dat) => {
                this.data.push({
                    img: {
                        file: undefined,
                        data: "",
                        publicUrl: dat.key,
                        uploadUrl: dat.signedUrl
                    },
                    picture: null,
                    header: "",
                    description: "",
                    size: 1, //1 -> 200px, 2 -> 400px
                    offset: -1,
                    ID: -1
                });
                this.isLoading = false;
            });
        },
        changeImage: function(_selIMG, selref){
            var reader = new FileReader();
            reader.onload = (e) => {
                console.log(_selIMG);
                if("data" in _selIMG) _selIMG.data = e.target.result;
                else _selIMG.img.data = e.target.result;
            }
            if(this.$refs[selref].length){
                reader.readAsDataURL(this.$refs[selref][0].files[0]);
                _selIMG.img.file = this.$refs[selref][0].files[0];
            }else{
                reader.readAsDataURL(this.$refs[selref].files[0]);
                _selIMG.file = this.$refs[selref].files[0];
            }
        },
        deleteSlot: function(i){
            let c = confirm("Are you sure you want to delete Timeline Slot #" + (i+1));
            if(c){
                this.data.splice(i, 1);
            }
        },
        deleteImg: function(i){
            let c = confirm("Are you sure you want to delete Image from Slot #" + (i+1));
            if(c){
                this.data[i].img.file = undefined;
                this.data[i].img.data = "";

                this.data[i].picture = null;
                this.$refs['imgsel' + i][0].value = '';
            }
        },
        submitThis: function(){
            if(this.ID){
                //update Logic
                this.updateThis();
            }else{
                this.createNew();
            }
        },
        updateThis: function(){
            let hasError = false;
            if(this.title.trim() == "") {this.$refs.cntTitle.classList.add("has-error"); hasError = true;}
            else this.$refs.cntTitle.classList.remove("has-error")

            this.data.forEach((slot, i) => {
                if(slot.header.trim() == "" || slot.description.trim() == ""){
                    this.$refs["cntCard-" + i][0].classList.add("has-error");
                    hasError = true;
                }else{
                    this.$refs["cntCard-" + i][0].classList.remove("has-error");
                }
            });

            if(!hasError){
                console.log("No errors, proceeding to upload");
                this.isLoading = true;
                setTimeout(() => {
                    if(this.thumbnail.file != undefined){
                        this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                            this.uploadImages(0);
                        });
                    }else{
                        this.uploadImages(0);
                    }
                }, 500);
            }else{
                alert("Please fix all the errors");
            }
        },
        createNew: function(){
            let hasError = false;
            if(this.title.trim() == "") {this.$refs.cntTitle.classList.add("has-error"); hasError = true;}
            else this.$refs.cntTitle.classList.remove("has-error")
            if(this.thumbnail.file == undefined) {this.$refs.cntThumb.classList.add("has-error"); hasError = true;}
            else this.$refs.cntThumb.classList.remove("has-error")
            if(this.data.length == 0){alert("No slots available for timeline, select minimum 1"); hasError = true;}

            this.data.forEach((slot, i) => {
                if(slot.header.trim() == "" || slot.description.trim() == ""){
                    this.$refs["cntCard-" + i][0].classList.add("has-error");
                    hasError = true;
                }else{
                    this.$refs["cntCard-" + i][0].classList.remove("has-error");
                }
            });

            if(!hasError){
                console.log("No errors, proceeding to upload");
                this.isLoading = true;
                setTimeout(() => {
                    this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                        this.uploadImages(0);
                    });
                }, 500);
            }
        },
        uploadImages: function(i){
            if(i < this.data.length){
                if(this.data[i].img.file != undefined){
                    //upload the file
                    this.functions.upload(this.data[i].img.uploadUrl, this.data[i].img.file, (dat) => {
                        this.uploadImages(i + 1);
                    });
                }else{
                    this.uploadImages(i+1);
                }
            }else{
                let componentData = this.composeData();
                if(this.ID){
                    this.functions.updateComponent(this.ID, componentData, (dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/timeline");
                    });
                }else{
                    this.functions.addComponent(componentData, (dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/timeline");
                    });
                }
            }
        },
        composeData: function(){
            let compData = {
                entrysizesum: this.data.length,
                entries: []
            };
            this.data.forEach((d,i) => {
                if(d.img.data.trim() != ""){
                    compData.entries.push({
                        ID: i+1,
                        header: d.header,
                        description: d.description,
                        size: d.size,
                        offset: i,
                        picture: d.img.publicUrl
                    });
                }else{
                    compData.entries.push({
                        ID: i+1,
                        header: d.header,
                        description: d.description,
                        size: d.size,
                        offset: i,
                        picture: null
                    });
                }
            });
            return {
                ContentType: "INTERACTIVE",
                Title: this.title,
                Thumbnail: this.thumbnail.publicUrl,
                Component: "timeline",
                Data: compData
            };
        },
    }
}
</script>

<style scoped>
textarea{
    width: 100%;
}
    .quill-editor{
        background: white;
        color: black;
    }
    .ql-container.ql-snow{
        background: white !important;
    }
    .submit-btn{
        width: 100%;
        height: 2em;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0.5em;
    }
    .has-error{
        border: red 5px solid !important;
        box-sizing: border-box;
    }
    .has-error::after{
        content: "Missing content/invalid content.";
        color: red;
        background: white;
        font-weight: 800;
    }
    hr{
        border: solid 2px white;
    }
    h2{
      color:black;
    }
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        font-size: 4em;
        font-weight: 900;
    }
    .x-cardbox{
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }
    .x-card {
        flex: 50%;
        text-align: center;
        box-sizing: border-box;
        border: 1px solid white;
        background: rgb(0,150,20);
        background: linear-gradient(6deg, rgba(0,150,20,1) 0%, rgba(0,0,0,1) 100%);
    }
    .x-card img{
        background: gray;
        object-fit: cover !important;
        width: 200px;
        height: 250px;
    }
    .x-card .size2{
        width: 400px !important;
    }
</style>